export const isMCQTypeOfPaper = (typeOfPaper) => {
    return typeOfPaper && typeOfPaper.pageType === 'question';
};
